import React from "react";
import { Layout } from 'antd'

class AuthLayout extends React.Component<{ children?: React.ReactNode }, any> {
    render(): React.ReactNode {
        const { children } = this.props;
        return (
            <Layout>
                <Layout.Content>
                    {children}
                </Layout.Content>
            </Layout>
        );
    }
}

export default AuthLayout;
